export default __webpack_public_path__ + "static/media/icn-verify-documents-off.8467fa95.svg";